<template>
  <div>
    <slot name="management_name">
      <slot></slot>
    </slot>
  </div>
</template>

<script>
export default {
  name: 'ManagementTitle'
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/groupManagement/ManagementTitle.vue